<script>
	import { onMount } from 'svelte';
	import { doFetch } from '../utils/Fetching.svelte';
	import { api_host } from '../stores.js';
	import { toast } from '@zerodevx/svelte-toast';


	export let uid;
	export let token;
	export let userId;
	export let params = {};
	
	onMount(async () => {
		if (!(params.uid && params.token && params.userId)) {
            toast.push('Invalid activation code', {
                duration: 3000,
                dismissable: false,
                theme: {
                    '--toastBackground': '#F56565',
                    '--toastProgressBackground': '#C53030'
                }
            });
		}

		const res = await doFetch(`${api_host}/auth/activate`, 'POST', {
			uid: params.uid,
			activateToken: params.token,
			userId: params.userId
		});
		if (res.msg == 'Successfully activated') {
            toast.push(res.msg, {
                duration: 3000,
                dismissable: false,
                theme: {
                    '--toastBackground': '#48BB78',
                    '--toastProgressBackground': '#2F855A'
                }
            });
			window.location.href = '/login';
		} else {
            toast.push(res.msg || 'Activation failed', {
                duration: 3000,
                dismissable: false,
                theme: {
                    '--toastBackground': '#F56565',
                    '--toastProgressBackground': '#C53030'
                }
            });
		}
	});
</script>

<div style="width: 100%;height: 100%;text-align: center;margin-top: 30px;">
	<h1>Activating...</h1>
</div>